/**
 * Calculates age from a birth date
 * @param birthDate - The birth date as Date object or string
 * @param roundToNearestYear - If true, rounds to the nearest year; otherwise floors to completed years
 * @returns The calculated age (number of years)
 */
export function calculateAgeFromBirthDate(
  birthDate: Date | string,
  roundToNearestYear: boolean = false,
): number {
  // Convert string to Date if needed
  const birth = birthDate instanceof Date ? birthDate : new Date(birthDate);

  // Get today's date
  const today = new Date();

  // Calculate months between dates
  const yearDiff = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  // Total months calculation (accounts for day differences too)
  let totalMonths = yearDiff * 12 + monthDiff;

  // Adjust for day differences
  if (dayDiff < 0) {
    totalMonths -= 1;
  }

  // Calculate age based on the rounding preference
  if (roundToNearestYear) {
    // Round to the nearest year
    return Math.round(totalMonths / 12);
  } else {
    // Floor to completed years
    return Math.floor(totalMonths / 12);
  }
}
